import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler
} from '@angular/common/http';
import { AuthStoreService } from '../services';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private store: AuthStoreService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (req.url.includes('/refresh-token')) {
        return next.handle(req);
    }

    const token = this.store.token();

    if (!token) {
      return next.handle(req);
    }

    const cloned = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      },
      withCredentials: true
    });

    return next.handle(cloned);
  }
}